import type { AppNotification } from '@discovr/types';
import type { NewNotificationPayload } from '@discovr/common';
import { outreachAlertCopy } from '../../campaign-detail/components/OutreachTab/sendGuardCopy';

/** An activity row's main line: the send-guard alerts in plain words, every other notification as Go wrote it. */
export function activityText(n: Pick<AppNotification, 'type' | 'title' | 'message' | 'metadata'>): string {
  return outreachAlertCopy({ type: n.type, metadata: n.metadata, body: n.message }) ?? (n.message || n.title);
}

/** A live toast's description. The SSE payload carries Go's sentence but no metadata. */
export function toastDescription(e: Pick<NewNotificationPayload, 'type' | 'action' | 'teaser' | 'body'>): string | undefined {
  return outreachAlertCopy({ type: e.type ?? e.action, body: e.body }) ?? e.teaser ?? e.body;
}
